import React, { useState, useEffect } from 'react'
import $, { get } from 'jquery'
import { changeParentOfCommunityMember, getDashboardTreeApi, getnewTreeApi } from '../CommunityActionCreator'
import Loader from '../../../../../presentationals/Loader/Loader.component'
// import ParentTree from './parentTree'
// import ParentPopup from './ChangeParentPopup'
import Alerts from '../../utils/SidePopup'
import { TextField } from '@mui/material'

const Dashboard = ({Detaildata}) => {
    const [parentTree, setSetParentTree] = useState(false)

    const [parentData, setparentData] = useState({})
    const [loaderState, setLoaderState] = useState(false)
    const [parentPopup, SetparentPopup] = useState(false)
    const [emailId, setEmailId] = useState('')
    const [communityCode, setcommunityCode] = useState('')
    const [sidePopup,setSidePopup]=useState(false)
    const [msg,setmsg]=useState('')



    useEffect(() => {
        getTreeData(Detaildata.communityId)
        setSetParentTree(false)
        // makeTreeHandler(treeData)
    }, [])
    const removePopup = () => {
        setTimeout(
            function () {
                setSidePopup(false)
                setmsg('')
            }.bind(this),
            5000
        );
    }
    const changeParent = () => {
        SetparentPopup(true)
    }
    const saveParent = () => {
        if (emailId || communityCode) {
            setLoaderState(true)
            changeParentOfCommunityMember(emailId, communityCode, Detaildata.communityId, callback => {
                console.log(callback, 'callback')
                if (callback === 'success') {
                    setLoaderState(false)
                    SetparentPopup(false)
                    setSidePopup(true)
                    setmsg('Successfully Done !')
                    removePopup()
                } else {
                    setSidePopup(true)
                    setmsg('Please try again later !')
                    setLoaderState(false)
                    removePopup()
                }
            })
        } else {
            alert('fill all data')
        }
    }
    const close = () => {
        SetparentPopup(false)
    }
    const parentHandler = (e, type) => {
        if (type === 'email') {
            setEmailId(e.target.value)
            setcommunityCode('')

        }
        if (type === 'communityCode') {
            setEmailId('')

            setcommunityCode(e.target.value)
        }
    }
    const getTreeData = (id) => {
        setLoaderState(true)
        getDashboardTreeApi(id, callBack => {
            makeTreeHandler(callBack)
            setLoaderState(false)
            // makeTreeHandler(newData)

        }, error => {

        })
    }


    const makeTreeHandler = (members) => {

        if (document.getElementById("containerFor" + Detaildata.communityId) == null) {
            var testImgSrc = "http://0.gravatar.com/avatar/06005cd2700c136d09e71838645d36ff?s=69&d=wavatar";
            // var j=0;
            (function heya(parentCommunityId, j) {
                // This is slow and iterates over each object everytime.
                // Removing each item from the array before re-iterating 
                // may be faster for large datasets.
                if (j == undefined) {
                    j = 0;
                }
                for (var i = 0; i < members.length; i++) {
                    var member = members[i];
                    // if (members.length === 1) {
                    //     if (member.parentCommunityId === parentCommunityId) {
                    //         var parent = parentCommunityId ? $("#containerFor" + parentCommunityId) : $("#mainTreeContainer"),
                    //             communityId = member.communityId,
                    //             communityName = (member.communityDetailDO.name).split(' ')[0] !== 'CA' && (member.communityDetailDO.name).split(' ')[0] !== 'CS' ? (member.communityDetailDO.name).split(' ')[0] : (member.communityDetailDO.name).split(' ')[1],
                    //             // metaInfo = "<div " + testImgSrc + "'/>" + member.otherInfo + " ($" + member.amount + ")";
                    //             metaInfo = "<div " + "'/>" + 'Name :  ' + member.communityDetailDO.name + '<br></br>' + 'Mobile Number:  ' + member.communityDetailDO.mobileNo + "";

                    //         parent.append("<div class='tree-container' id='containerFor" + communityId + "'><div class='member'>" + communityName + "<div class='metaInfo'>" + metaInfo + "</div></div></div>");
                    //         // parent.append("<div class='tree-container' id='containerFor" + communityId + "'><div class='member'>" + communityName + "</div></div>");
                    //         // parent.click(getCommunityData(communityId));
                    //         parent.on("click", (e) => getCommunityData(e));
                    //         heya(communityId);
                    //     }
                    // }
                    // if (members.length > 1) {
                    if (member.parentCommunityId === parentCommunityId) {
                        var parent = parentCommunityId ? $("#containerFor" + parentCommunityId) : $("#mainTreeContainer"),
                            communityId = member.communityId,
                            communityName = (member.communityDetailDO.name).split(' ')[0] !== 'CA' && (member.communityDetailDO.name).split(' ')[0] !== 'CS' ? (member.communityDetailDO.name).split(' ')[0] : (member.communityDetailDO.name).split(' ')[1],
                            // metaInfo = "<div " + testImgSrc + "'/>" + member.otherInfo + " ($" + member.amount + ")";
                            metaInfo = "<div " + "'/>" + 'Name :  ' + member.communityDetailDO.name + '<br></br>' + 'Mobile Number:  ' + member.communityDetailDO.mobileNo + "";

                        parent.append("<div class='tree-container' id='containerFor" + communityId + "'><div class='member'>" + communityName + "<div class='metaInfo'>" + metaInfo + "</div></div></div>");
                        // parent.append("<div class='tree-container' id='containerFor" + communityId + "'><div class='member'>" + communityName + "</div></div>");
                        // parent.click(getCommunityData(communityId));
                        if (j === 0) {

                            parent.on("click", (e) => getCommunityData(e));
                        } else {
                        }
                        heya(communityId, j + 1);
                        // }
                    }
                }
            }(null));

            // makes it pretty:
            // recursivley resizes all children to fit within the parent.
            var pretty = function () {
                var self = $(this),
                    children = self.children(".tree-container"),
                    // subtract 4% for margin/padding/borders.
                    width = (100 / children.length) - 1;
                children
                    .css("width", width + "%")
                    .each(pretty);

            };
            $("#mainTreeContainer").each(pretty);
        }


    }
    const getCommunityData = (data) => {
        if (data && data.target !== undefined) {
            let commId = data.target.parentNode.id.split('containerFor')
            if (commId && commId[1]) {
                if (commId[1] === Detaildata.communityId) {
                    setSetParentTree(true)
                    setparentData(commId[1])
                    getTreeDataParent(commId[1])
                }
            }
        }
    }

    const getTreeDataParent = (id) => {
        setLoaderState(true)
        getnewTreeApi(id, callBack => {
            makeTreeHandler(callBack)
            setLoaderState(false)
            // makeTreeHandler(newData)

        }, error => {

        })
    }
    const backToCommunityTree = () => {
        setSetParentTree(false)
        getTreeData(Detaildata.communityId)
        // console.log(document.getElementById('mainTreeContainer').setAttribute)
        document.getElementById('mainTreeContainer').removeAttribute('value', '')
    }

    return (
        <div>
            {loaderState ?
                <Loader />
                : ""}
            {parentTree === true ?
                <ParentTree
                    changeParent={changeParent}
                    backToCommunityTree={backToCommunityTree}
                />
                : ""}
            {parentTree === false ?
                <div className='container-fluid'>
                    <div className='col-xs-12 clearfix' id="mainTreeContainer" ></div>
                </div>
                : ""}
            {parentPopup ?
                <ParentPopup
                    emailId={emailId}
                    communityCode={communityCode}
                    parentHandler={parentHandler}
                    close={close}
                    saveParent={saveParent}
                />

                : ""}
                {sidePopup?

<Alerts msg={msg}/>
               :"" }
        </div>
    )
}

export default Dashboard;



const ParentTree  =({backToCommunityTree,changeParent})=>(
    <div className='container-fluid'>
        <button className='cred-btn mt-2' onClick={()=>backToCommunityTree()}>Back To Community Tree</button>
        <button className='cred-btn mt-2' onClick={()=>changeParent()}>Change Parent </button>

    <div className='col-xs-12 clearfix' id="mainTreeContainer" ></div>
</div>
)

const ParentPopup = ({ close, parentHandler, communityCode, emailId, saveParent }) => (
    <div className="background-blur" style={{ top: 0, }} >
        <div className="popup-contact-us text-center" style={{ marginTop: '10%', overflow: 'auto' }}>
            <div className="text-right">
                <i className='fa fa-close' style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }} onClick={() => close()}></i>
            </div>
            <h4 className='text-center'><b>Change Parent</b></h4>
            <div className=' mt-5 mb-3'>
                {/* <div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }}> */}
                <TextField value={emailId} style={{ width: '80%',marginLeft:'auto',marginRight:'auto' }} label='Email Id' onChange={(e) => parentHandler(e, 'email')} />
                {/* </div> */}
            </div>
            <div className='text-center'>OR</div>
            <div className='mt-3'>
                {/* <div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }}> */}
                <TextField value={communityCode} style={{ width: '80%',marginLeft:'auto',marginRight:'auto' }} label='Community Code' onChange={(e) => parentHandler(e, 'communityCode')} />
                {/* </div> */}

            </div>
            <div className='text-center mt-5'>
                <button className='cred-btn' onClick={() => saveParent()}>Save</button>
            </div>
        </div>
    </div>
)